import { UniFiCategoryId, UniFiChildCategorySlug } from '../../../proStoreCategories/mapping/unifi.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Assets-V4/Switching/pro-xg-24-poe@2x.jpg.mjs';
import '../../assets/Switching/ProfessionalXG/professionalXg24PoE.jpg.mjs';
import { productListSwitchingProfessional } from '../product-list-groups/productListSwitchingProfessional.mjs';
import '../properties/index.mjs';
import { portCount } from '../properties/portCount.mjs';
import { downlinkSpeed } from '../properties/downlinkSpeed.mjs';
import { uplinkSpeed } from '../properties/uplinkSpeed.mjs';
import { poeOutput } from '../properties/poeOutput.mjs';
import { poeAvailability } from '../properties/poeAvailability.mjs';
import { etherlighting } from '../properties/etherlighting.mjs';
import { proAvSupport } from '../properties/proAvSupport.mjs';
import v3Image__default from "../../../../assets/professionalXg24PoE.jpg";
import image__default from "../../../../assets/pro-xg-24-poe@2x.jpg";
"use strict";
const professionalXg24PoE = {
  id: "professionalXg24PoE",
  productTitle: "Pro XG 24 PoE",
  description: "professionalXg24PoE.description",
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
    productSlug: "usw-pro-xg-24-poe"
  },
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.Switching}/usw-pro-xg-24-poe`],
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 242,
    height: 120
  },
  isNew: true,
  productListGroup: productListSwitchingProfessional,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '442 x 480 x 44 mm\n(17.4 x 18.9 x 1.7")'
    }
  }, {
    propertyId: portCount.id,
    value: {
      type: "string",
      value: "24 + 2 SFP28"
    }
  }, {
    propertyId: downlinkSpeed.id,
    value: {
      type: "translation",
      value: "commons.speed.upTo10Gbps"
    }
  }, {
    propertyId: uplinkSpeed.id,
    value: {
      type: "string",
      value: "25 Gbps"
    }
  }, {
    propertyId: poeOutput.id,
    value: {
      type: "string",
      value: "PoE+++"
    }
  }, {
    propertyId: poeAvailability.id,
    value: {
      type: "string",
      value: "720 W"
    }
  }, {
    propertyId: etherlighting.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: proAvSupport.id,
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "generalRedundancy",
    value: {
      type: "translation",
      value: "commons.powerRedundancy.dcPowerBackup"
    }
  }, {
    propertyId: "mounting",
    value: {
      type: "translation",
      value: "commons.mounting.rack"
    }
  }]
};
export { professionalXg24PoE };
//# sourceMappingURL=professionalXg24PoE.mjs.map
